import { useTranslation } from 'react-i18next';

import { ReactComponent as User } from 'assets/icons/User.svg';
import useMatrixContext from 'contexts/MatrixContext/useMatrixContext';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import useWorkspacesContext from 'modules/Workspaces/WorkspacesProvider/useWorkspacesContext';
import { isWorkspaceBotJoined } from 'utils/botUtils';

import WorkspaceDeleteSetting from './WorkspaceDeleteSetting';
import WorkspaceLeaveSetting from './WorkspaceLeaveSetting';

const GeneralSettingsSection = () => {
  const { t } = useTranslation();
  const { matrixClient } = useMatrixContext();
  const { workspaceId, workspacePermissions } = useWorkspacesContext({ requireWorkspaceId: true });

  const canDeleteWorkspace =
    workspacePermissions.workspaceDelete && !!workspaceId && isWorkspaceBotJoined(matrixClient, workspaceId);

  return (
    <SettingsCard>
      <div className="w-full h-full p-2">
        <SettingsCard.Header title={t('workspaces.management')} icon={User} />
        <SettingsCard.Content>
          <div className="flex flex-col space-y-4">
            <WorkspaceLeaveSetting />
            {canDeleteWorkspace && <WorkspaceDeleteSetting />}
          </div>
        </SettingsCard.Content>
      </div>
    </SettingsCard>
  );
};

export default GeneralSettingsSection;
